import { render, staticRenderFns } from "./ProductItemLinkUpdate.vue?vue&type=template&id=817df3de&"
import script from "./ProductItemLinkUpdate.vue?vue&type=script&lang=js&"
export * from "./ProductItemLinkUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports